import React, {Component} from 'react';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { filterBy } from '@progress/kendo-data-query';

export class index extends Component {
    constructor(props){
        super(props);

        this.state = {
        allData :  [],   
        subsetData: [],
        skip: 0,
        pageSize:10,
        total: 0,
        filteredData : [],
        value: [],
    }
    }

    onFilterChange = (event) => {
        const filter = event.filter;
        const filteredData = filterBy(this.state.allData.slice(), filter);

        const data = filteredData.slice(0, this.state.pageSize);

        this.setState({
            subsetData: data,
            skip: 0,
            total: filteredData.length
        });
    }

    pageChange = (event) => {
        const skip = event.page.skip;
        const take = event.page.take;
        const newSubsetData = this.state.filteredData.slice(skip, skip + take);

        this.setState({
            subsetData: newSubsetData,
            skip: skip
        });
    }

    onChange=(event)=>{
        this.setState({
            value: [ ...event.target.value ]
        },()=>{this.props.send(this.state.value)});
       
    }

    componentDidMount(){
        this.setState({
            allData : this.props.data,
            subsetData: this.props.data.slice(0,this.state.pageSize),
            total: this.props.data.length  ,
            value: this.props.value
        },()=>{
            this.setState({filteredData : [...this.state.allData] })
        })
    }
    componentDidUpdate(){
        if(this.state.value !== this.props.value){
            this.setState({value : this.props.value})
        }
    }

    render() {
        const {dataItemKey, textField} = this.props
        return (
            <MultiSelect
                data={this.state.subsetData}
                dataItemKey={dataItemKey}
                textField={textField}
                value={this.state.value}
                virtual={{
                    total: this.state.total,
                    pageSize: this.state.pageSize,
                    skip: this.state.skip
                }}
                onPageChange={this.pageChange}
                filterable={true}
                onFilterChange={this.onFilterChange}
                onChange={this.onChange}
                disabled={this.props.disabled ? true  : false}
                popupSettings={{
                    height: '150px'
                }}
            />
        );
    }
}

export default index
